import it from "./it";

const en: typeof it = {
  screens: {
    board: {
      formTitle: "Titolo",
      formColor: "Categoria",
      formTaskType: "Tipologia",
      formTaskTypePlanning: "Pianificazione",
      formTaskTypeActivity: "Task",
      cancelButton: "Annulla",
      deleteButton: "Elimina",
      confirmButton: "Conferma",
      logoutButton: "Logout",
      settings: "Impostazioni",
      elapsedTime: "Ore lavorate",
      project: "Progetto",
      toolbar: {
        integrations: "Integrazioni",
        plugins: {
          googleCalendar: "Google calendar",
        },
      },
      board: "Board",
      preferences: {
        allDaySlot: "Slot eventi giornalieri",
        weekends: "Weekend",
        slotDuration: "Dimensione slot",
        slotRangeTime: "Fascia oraria",
        slotMinTime: "Ora di inizio",
        slotMaxTime: "Ora di fine",
        businessDaysOfWeek: "Giornate lavorative",
        businessRangeTime: "Fascia oraria lavorativa",
        businessStartTime: "Orario di inizio lavoro",
        businessEndTime: "Ora di fine lavoro",
      },
      event: {
        addEventTitle: "Aggiungi attività",
        editEventTitle: "Modifica attività",
        noProjectCategory: "Nessuna categoria",
        deleteTitle: "Elimina attività",
        deleteRecurrenceTitle: "Elimina attività ricorrente",
        onlyThisEvent: "Questa attività",
        thisEventAndFollowing: "Questa attività e quelle successive",
        deleteMessage: "Sei sicuro di voler eliminare questa attività?",
      },
      recurrence: {
        editRecurringEvent: "Modifica evento periodico",
        onlyThis: "Questo evento",
        thisAndFollowingOnes: "Questo evento e quelli successivi",
      },
    },
    login: {
      title: "Login",
      login: "Login",
      signUp: "Registrazione",
      ctaLogin: "Sign in with Google",
      notSignup: "Non hai un account?",
      alreadySignup: "Hai già un account?",
      ctaSignup: "Registrati",
      nominative: "Nominativo",
      email: "Email",
      password: "Password",
      confirmPassword: "Conferma password",
      loginError: "Email o password errati",
      signUpError: "Errore",
      lostPassword: "HO DIMENTICATO LA PASSWORD",
      button: "CONFIRM",
      validations: {
        emailRequired: "Email obbligatoria",
        passwordRequired: "Password obbligatoria",
      },
    },
    lostPassword: {
      title: "Forgot password",
      lostPassword: "Torna al login",
      sendRecoveryLink: "Recupera password",
      requestSuccess:
        "Richiesta eseguita correttamente. Riceverai una mail con le indicazioni da seguire!",
    },
    changePassword: {
      title: "Cambio password",
      newPassword: "Nuova password",
      back: "BACK TO LOGIN",
      confirmNewPassword: "Conferma password",
    },
    signUp: {
      title: "Registration",
      name: "Name",
      surname: "Surname",
      email: "Email",
      password: "Password",
      confirmPassword: "Conferma password",
      button: "CONFIRM",
      completeSignup: "Completa registrazione",
      hasAccount: "HO GIÀ UN ACCOUNT",
      validations: {
        nameRequired: "Nome obbligatorio",
        surnameRequired: "Cognome obbligatorio",
        emailRequired: "Email obbligatoria",
        passwordRequired: "Password obbligatoria",
        passwordsNotMatch: "Password non corretta",
      },
    },
    clients: {
      title: "Clienti",
      newButton: "NUOVO",
      name: "nome",
      surname: "cognome",
      email: "email",
      subscriptionState: "stato abbonamento",
      statuslist: {
        active: "Attivo",
        disactive: "Non attivo",
      },
    },
    admins: {
      title: "Admins",
      newButton: "NEW",
      adminModal: {
        typeNew: "Crea admin",
      },
    },
    client: {
      deleteCustomer: "Cancella cliente",
      deleteCustomerMessage:
        "Sei sicuro? Non puoi annullare questa azione in seguito.",
      editClient: "EDIT",
      tabs: {
        profile: "Profile",
        subscription: "Subscription",
        objectives: "Objectives",
        evaluations: "Evaluations",
        trainings: "Rrainings",
        comunications: "Comunications",
        emails: "Emails",
      },
      customerTableHead: {
        name: "Nome",
        surname: "Cognome",
        email: "Email",
        registrationDate: "Data registrazione",
        cancellationDate: "Data cancellazione",
        subscription: "Abbonamento",
        subscriptionState: {
          trial: "IN PROVA",
          active: "ATTIVO",
          inactive: "NON ATTIVO",
          disactive: "CANCELLATO",
          "trial-expired": "PROVA SCADUTA",
          cancelled: "IN CANCELLAZIONE",
        },
      },
      clientModal: {
        typeEdit: "Modifica cliente",
        typeNew: "Crea cliente",
      },
      clientForm: {
        name: "Nome",
        surname: "Cognome",
        phone: "Cellulare",
        contact_emergency: "Contatto d'emergenza",
        email: "Email",
        fb: "Facebook",
        ig: "Instagram",
        contact_preference: "Preferenza di contatto",
        assistance_type: "Tipo di assistenza",
        address: "Indirizzo di residenza",
        city: "Città",
        zipCode: "CAP",
        state: "Stato",
        province: "Provincia",
        gender: "Sesso",
        birth_date: "Data di nascita",
        picture: "Foto profilo",
        periodic_evaluation: "Valutazione periodica",
        note: "Nota",
        buttonSubmit: "Salva",
        buttonClose: "Annulla",
        contactPreferences: {
          mobile: "Cellulare",
          whatsapp: "Whatsapp",
          mail: "Mail",
          no: "No",
        },
        genderOptions: {
          f: "Donna",
          m: "Uomo",
        },
        assistanceTypes: {
          none: "No assistenza",
          littleAssistance: "Poca assistenza",
          needsAssistance: "Necessita assistenza",
        },
      },
      clientValidations: {
        nameRequired: "Nome obbligatorio",
        surnameRequired: "Cognome obbligatorio",
        phoneRequired: "Cellulare obbligatorio",
        emailRequired: "Email obbligatoria",
        addressRequired: "Indirizzo di residenza obbligaotrio",
        provinceRequired: "Provincia obbligatoria",
        genderRequired: "Deve essere selezionata il tipo donna",
        birth_dateRequired: "Data di nascita obbligatorio",
        periodic_evaluationRequired: "Valutazione periodica",
        stateRequired: "Stato obbligatorio",
        flPrivacyPolicy: "La privacy policy deve essere accettata",
      },
      emailTableHead: {
        username: "USERNAME",
        data: "DATA",
        object: "OGGETTO",
        body: "CORPO",
      },
      emailModal: {
        typeEdit: "Modifica email",
        typeNew: "Crea email",
      },
      emailForm: {
        username: "Username",
        data: "Data",
        object: "Oggetto",
        body: "Corpo",
        submitError: "Errore salvataggio",
      },
      emailFormValidations: {
        usernameRequired: "Username obbligatorio",
        dataRequired: "Data obbligatorio",
        objectRequired: "Oggetto obbligatorio",
        bodyRequired: "Corpo obbligatorio",
      },
      emailAccordionDelete: {
        title: "Delete email",
        dialog: "Are you sure? You can't undo this action afterwards.",
        deleteError: "Errore eliminazione",
      },
      activitiesTable: {
        date: "Data",
        type: "Tipologia",
        name: "Nome",
        duration: "Durata",
      },
      activitiesDialog: {
        title: "Elimina",
        text: "Sicuro di voler eliminare la prenotazione?",
      },
      comunicationTableHead: {
        data: "DATA",
        operator: "OPERATORE",
        comunication_direction: "DIREZIONE",
        duration: "DURATA",
        note: "CORPO",
      },
      comunicationModal: {
        typeEdit: "Modifica comunicazione",
        typeNew: "Crea comunicazione",
      },
      comunicationForm: {
        data: "Data",
        operator: "Operatore",
        comunication_direction: "Direzione comunicazione",
        type: "Tipo",
        note: "Nota",
        duration: "Durata",
        submitError: "Errore salvataggio",
        noteTextAreaPlaceholder: "Type something...",
      },
      comunicationFormValidations: {
        dataRequired: "Data obbligatorio",
        operatorRequired: "Operatore obbligatorio",
        comunicationDirectionRequired: "Direzione comunicazione obbligatoria",
        durationRequired: "Durata obbligatoria",
        typeRequired: "Tipo obbligatorio",
        noteRequired: "Nota obbligatorio",
      },
      comunicationAccordionDelete: {
        title: "Delete comunication",
        dialog: "Are you sure? You can't undo this action afterwards.",
        deleteError: "Errore eliminazione",
      },
      personalObjective: {
        title: "Obiettivo",
        height: "Altezza (cm)",
        weight: "Peso (kg))",
        lean_mass: "Massa grassa (%)",
      },
      personalObjectiveModal: {
        typeEdit: "Modifica obiettivo",
        typeNew: "Nuovo obiettivo",
        typeShow: "Visualizza obiettivo",
      },
      personalObjectiveForm: {
        data: "Data",
        height: "Altezza (cm)",
        weight: "Peso (kg)",
        lean_mass: "Massa grassa (%)",
        breast: "Seno (cm)",
        waist: "Vita (cm)",
        thigh: "Coscia (cm)",
      },
      personalObjectiveFormValidations: {
        dataRequired: "Data obbligatorio",
        heightRequired: "Altezza obbligatoria",
        weightRequired: "Peso obbligatorio",
      },
      genericObjective: {
        title: "Obiettivi generici",
        completed: "Rimuovi",
        edit: "Edit",
        show: "Show",
      },
      genericObjectiveModal: {
        typeEdit: "Modifica obiettivo",
        typeNew: "Nuovo obiettivo",
      },
      genericObjectiveForm: {
        title: "Titolo",
        description: "Descrizione",
      },
      genericObjectiveFormValidations: {
        titleRequired: "Titolo obbligatorio",
        descriptionRequired: "Descrizione obbligatoria",
      },
      customer: {
        onlineTraning: "Online traning",
        fillMonthlyEvaluation: "Monthly evaluation",
        selectVideoCategory: "Select one category",
      },
      evaluation: {
        title: "Obiettivi generici",
        btnNew: "NUOVA",
      },
      evaluationModal: {
        typeEdit: "Modifica valutazione",
        typeNew: "Nuova valutazione",
      },
      evaluationForm: {
        results: "Results",
        objectives: "Objectives",
        data: "Data",
        height: "Altezza",
        weight: "Peso",
        lean_mass: "Massa grassa",
        breast: "Seno",
        waist: "Vita",
        thigh: "Coscia",
        valutation: "Valutazione",
        title: "Titolo",
        comment: "Commento",
        description: "Descrizione",
        personalObjective: "Obiettivo personale",
        photo: "Foto",
        uploadPhoto: "Carica una foto attuale del tuo corpo",
      },
      evaluationFormValidations: {
        dataRequired: "Data obbligatoria",
        weightRequired: "Peso obbligatorio",
        personalObjectiveRequired: "Obiettivo personale obbligatoria",
        commentRequired: "Commento obbligatorio",
        valuationRequired: "Valutazione obbligatoria",
        valutationMin: "Selezione obbligatoria",
      },
      evaluationAccordionDelete: {
        title: "Delete evaluation",
        dialog: "Are you sure? You can't undo this action afterwards.",
        deleteError: "Errore eliminazione",
      },
      planningModal: {
        typeEdit: "Modifica pianificazione",
        typeNew: "Pianifica allenamento",
        day: "Giorno di allenamento",
        type: "Tipo di allenamento",
        types: {
          LIVE_WORKOUT: "Allenamento in diretta",
          RECORDED_WORKOUT: "Allenamento registrato",
          NO_WORKOUT: "Nessun allenamento",
        },
      },
      subscription: {
        subscription: "Subscription",
        startDate: "Start date",
        endDate: "End date",
        id: "ID",
        amount: "Amount",
        currency: "Currency",
        created: "Created",
        customer: "Customer",
        paid: "Paid",
        refunded: "Refunded",
        status: "Status",
      },
      clientObjectives: {
        title: "I miei obiettivi",
      },
    },
    adminSettings: {
      title: "Settings",
      vimeo: "Vimeo",
      vimeoVideoCategories: "Video categories",
      vimeoVideoCategoriesForm: {
        vimeoDoc: "Cartella vimeo",
        state: "State",
        title: "Title",
        description: "Description",
        order: "Order",
        badgeActive: "Active",
        badgeNotActive: "Not active",
      },
      calendly: "Calendly",
      calendarSessionCoaching: "Session Coaching Calendar",
      calendlyLiveTraining: "Calendario allenamenti in diretta",
      calendlyBookingPersonalTrainerActiveSub:
        "Calendario prenotazione Personal Trainer - Abbonamento ATTIVO",
      calendlyBookingPersonalTrainerInActiveSub:
        "Calendario prenotazione Personal Trainer - Abbonamento NON ATTIVO",
      supervisionedWorkouts: {
        title: "Allenamenti con supervisione",
        step1Video: "Step 1 - Video riscaldamento",
        step1Message: "Step 1 - Messaggio",
        step2ZoomLink: "Step 2 - Link Diretta Zoom",
        step2Message: "Step 2 - Messaggio",
        step3Video: "Step 3 - Video stretching",
        step3Message: "Step 3 - Messaggio",
        timetables: "Timetables",
        day: "Day",
        slot1: "Slot 1",
        slot2: "Slot 2",
      },
      timetables: "Timetables",
      uploadTimetable: "Upload timetables",
      videoCategoryModal: {
        typeEdit: "Edit category",
        typeNew: "New category",
      },
      videoCategoryForm: {
        name: "Nome",
        title: "Title",
        description: "Description",
        order: "Order",
        enabled: "State",
        active: "Active",
        notActive: "Not active",
      },
    },
    customerLongLiveTraining: {
      title: "Allenamenti con supervisione",
      subtitle: "",
      bttStart: "Avvia la tua sessioen di allenamento",
      startingSession: "Apertura sessione in corso...",
      lobbyTitle: "È stato raggiunto il numero massimo di utenti.",
      lobbyQueue:
        "Attualmente hai {{queue}} persone davanti a te. Non abbandonare la pagina per non perdere il tuo turno!",
      endedSession: "Sessione di allenamento terminata",
    },
    reports: {
      title: "Reports",
      tabsTitle: {
        subscriptionCancellation: "Abbonamenti cancellati",
        emptyWeight: "Nessun obbiettivo",
        emptyEvaluation: "Nessuna valutazione",
        subscriptionTrial: "Abbonamenti in prova",
        fewWorkouts: "Pochi allenamenti",
      },
      tabSubscriptionCancellation: {
        daysNumber: "Numero giorni",
        daysNumberPlaceholder: "Inserisci il numero giorni",
      },
    },
  },
  nav: {
    customers: "Customers",
    reports: "Reportistica",
    customersInactive: "Inactive subscription",
    admins: "Admins",
    settings: "Settings",
    profile: "Profile",
    logout: "Log out",
  },
  common: {
    action: "Action",
    delete: "Delete",
    edit: "Edit",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    yes: "Yes",
    no: "No",
    search: "Search",
    reset: "Reset",
    actionExecutedSuccessfully: "Action performed successfully",
    error: "Something went wrong. Please try again",
    requiredField: "Required field",
    cleanFilters: "Remove filters",
    refresh: "Refresh",
    create: "Create",
    backToLogin: "Back to login",
    next: "Next",
    back: "Back",
    upload: "Upload",
    close: "Chiudi",
    continue: "Continua",
    dndMessage: "Drag 'n' drop some files here, or click to select files",
  },
  profile: {
    profile: "Profile",
    myAccount: "My account",
    myProfile: "My profile",
    email: "Email",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    changeImage: "Change image",
    emailRequired: "Email is required",
    trialMessage: "Hai ancora {{days}} giorni per attivare il tuo abbonamento",
    trialExpiredMessage: "Il periodo di prova è terminato",
    subscriptionDeactivatedMessage: "Il tuo abbonamento è terminato",
    subscriptionActivateNow: "Riattiva ora",
    clickHere: "Clicca qui",
    activateSubscription: "Attiva abbonamento",
    manageSubscription: "Gestisci abbonamento",
    activateNow: "Attiva ora il tuo abbonamento",
  },
  calendar: {
    today: "Oggi",
  },
  days: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
  },
  shortDays: {
    Mon: "Lun",
    Tue: "Mar",
    Wed: "Mer",
    Thu: "Gio",
    Fri: "Ven",
    Sat: "Sab",
    Sun: "Dom",
  },
  dayOfWeek: {
    0: "Sunday",
    1: "Monday",
    2: "Thuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  },
  dayOfWeekShort: {
    0: "S",
    1: "M",
    2: "T",
    3: "W",
    4: "T",
    5: "F",
    6: "S",
  },
  months: {
    0: "Jennuary",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "Agoust",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  },
};

export default en;
